(function () {
  if (window.__nagaiaThrottleFix) return;
  window.__nagaiaThrottleFix = true;

  var nativeFetch = window.fetch.bind(window);

  function urlOf(input) {
    try { return (typeof input === 'string') ? input : (input && input.url) || ''; }
    catch (e) { return ''; }
  }

  /* 1) Lazy search prefetch: hold the big products.json request(s) until the
        shopper focuses the collection search box. Removes two heavy requests
        from every page load (a key trigger of Shopify's 429 rate limit). */
  var searchFocused = false;
  var pendingPrefetch = [];
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.id === 'nagaia-collection-search' && !searchFocused) {
      searchFocused = true;
      var q = pendingPrefetch.splice(0);
      q.forEach(function (fn) { fn(); });
    }
  });
  function isPrefetch(u) {
    return u.indexOf('/products.json') !== -1 && u.indexOf('limit=250') !== -1;
  }

  /* 2) De-dupe rapid GET /cart.js (several scripts request it on load). */
  var cartCache = null, cartCacheAt = 0;
  var CART_WINDOW = 1200;

  window.fetch = function (input, init) {
    var u = urlOf(input);
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();

    if (method === 'GET' && isPrefetch(u)) {
      var hasSearch = document.getElementById('nagaia-collection-search');
      if (hasSearch && !searchFocused) {
        return new Promise(function (resolve, reject) {
          pendingPrefetch.push(function () { nativeFetch(input, init).then(resolve, reject); });
        });
      }
      return nativeFetch(input, init);
    }

    if (method === 'GET' && u.indexOf('/cart.js') !== -1) {
      var now = Date.now();
      if (cartCache && (now - cartCacheAt) < CART_WINDOW) {
        return Promise.resolve(cartCache.clone());
      }
      return nativeFetch(input, init).then(function (res) {
        try { cartCache = res.clone(); cartCacheAt = Date.now(); } catch (e) {}
        return res;
      });
    }

    /* Any cart MUTATION invalidates the cached /cart.js -- otherwise a
       rapid follow-up read (badge refresh, add verification) can be
       served a stale cart. */
    if (method === 'POST' && u.indexOf('/cart/') !== -1) {
      return nativeFetch(input, init).then(
        function (res) { cartCache = null; return res; },
        function (err) { cartCache = null; throw err; }
      );
    }

    /* Everything else: pass through exactly once. We deliberately do
       NOT retry /cart/add.js: a 429 can arrive AFTER the item was
       already added, so retrying produced duplicate items. */
    return nativeFetch(input, init);
  };
})();
